// AwakenCard.jsx
import { useState } from 'react';
import { handleShare } from '../MarketingUtils/Share';

export default function AwakenCard() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="bg-indigo-900 text-white p-6 rounded-2xl mt-8 shadow-lg text-center max-w-md mx-auto relative">
      <button
        className="absolute top-3 right-4 text-indigo-200 hover:text-white text-2xl font-bold focus:outline-none"
        aria-label="Close"
        onClick={() => setOpen(false)}
        style={{ lineHeight: 1 }}
      >
        &times;
      </button>
      <h3 className="text-2xl font-bold mb-2">Invite More People</h3>
      <p className="text-sm opacity-90">
        Your voice can make an impact. Share Andlegur and help others find purpose, courage, and light.
      </p>
      <button
        className="mt-4 bg-rose-500 hover:bg-indigo-600 text-indigo-50 px-4 py-2 rounded-xl transition"
        onClick={() => handleShare(window.location.origin + '/')}
      >
        Share Now
      </button>
    </div>
  );
}
